import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth,
} from '@app/enumerations';

const styles = (theme: Theme) => {
	return createStyles({
		notifications_snackbar: {
			cursor: 'pointer',
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				width: '300px',
			},
		},
		notifications_variantWarning: {
			backgroundColor: `${theme.palette.warning.main} !important`,
		},
		notifications_variantError: {
			backgroundColor: `${theme.palette.error.main} !important`,
		},
		notifications_variantInfo: {
			backgroundColor: `${theme.palette.info.main} !important`,
		},
		notifications_variantSuccess: {
			backgroundColor: `${theme.palette.success.main} !important`,
		},
	});
}

export default styles;
